module.exports = __webpack_public_path__ + "static/NearBooks-33da0946137a3e4afc1815d8c31f8e5c.png";